<template>
  <v-card v-if="campania" outlined class="inicio-novedad mb-4" data-test="inicio-novedad">
    <div class="inicio-novedad-icono grey lighten-4">
      <v-icon class="primary--text text--darken-2">mdi-bullhorn-outline</v-icon>
    </div>
    <div class="inicio-novedad-cuerpo">
      <div class="d-flex align-center flex-wrap inicio-novedad-encabezado">
        <span class="inicio-novedad-titulo">{{ campania.titulo }}</span>
        <v-chip x-small label color="primary" class="white--text inicio-novedad-chip">Novedad</v-chip>
      </div>
      <div v-if="campania.texto" class="inicio-novedad-texto">{{ campania.texto }}</div>
    </div>
    <v-btn text small class="primary--text text--darken-2 inicio-novedad-boton" data-test="banner-boton" @click="ir">
      {{ campania.boton_texto || "Ver más" }}
      <v-icon right small>mdi-arrow-right</v-icon>
    </v-btn>
    <v-btn icon small aria-label="Cerrar" data-test="banner-cerrar" @click="cerrar">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import { abrirEnlaceCampania } from "@/utils/publicidadEnlace";

/**
 * Banner discreto del Inicio, entre la bienvenida y los accesos rápidos.
 * Lee la campaña de tipo "banner" del store y no renderiza nada si no hay.
 */
export default {
  name: "BannerInicio",
  computed: {
    campania() {
      const porTipo = this.$store.getters["publicidad/porTipo"] || {};
      return porTipo.banner || null;
    },
  },
  watch: {
    campania: {
      immediate: true,
      handler(campania, anterior) {
        if (campania && (!anterior || anterior.id !== campania.id)) {
          this.$store.dispatch("publicidad/verVista", campania.id);
        }
      },
    },
  },
  methods: {
    ir() {
      this.$store.dispatch("publicidad/clic", this.campania.id);
      abrirEnlaceCampania(this.campania.boton_url);
    },
    cerrar() {
      this.$store.dispatch("publicidad/cerrar", this.campania.id);
    },
  },
};
</script>

<style scoped>
.inicio-novedad {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 88px;
  padding: 12px 12px 12px 16px;
  border-radius: 8px !important;
  border-left: 3px solid var(--v-primary-base) !important;
}
.inicio-novedad-icono {
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.inicio-novedad-cuerpo {
  flex: 1 1 auto;
  min-width: 0;
}
.inicio-novedad-encabezado {
  gap: 8px;
}
.inicio-novedad-titulo {
  font-size: 15px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}
.inicio-novedad-chip {
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.inicio-novedad-texto {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.inicio-novedad-boton {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
  flex-shrink: 0;
}
</style>
